document.addEventListener("DOMContentLoaded", () => {
  initTabs();
  initToggleGroups();
  initProductSlider();
  initTestimonialsSlider();
  clpthumbnail();
  initProductThumbs();
  initCardContentToggle();
  initJobsSections();
  if (!document.body.classList.contains("template-index")) {
    initSliderDots();
  }
  initPopupRecommendedSlider();
  clampTagRows();
});

// ---------------------------------------------------------------------------
// Badges der Produktkarte auf zwei Reihen begrenzen.
//
// Warum gemessen und nicht per CSS: Eine feste Hoehe kann es nicht, weil ein
// langes Badge in sich umbricht und dann doppelt so hoch ist - die Hoehe schnitte
// mitten hinein. Eine feste ANZAHL kann es auch nicht, weil je nach Kartenbreite
// mal zwei, mal nur ein Badge in eine Reihe passt: bei 1280px sind
// "Hohe Dämpfung" + "100% Zehenfreiheit" zusammen 264px und passen in die 272px
// breite Karte, "Hallux valgus geeignet" + "Hohe Dämpfung" mit 293px nicht mehr.
// Nur Messen liefert bei jeder Breite genau zwei Reihen, ohne etwas anzuschneiden.
// ---------------------------------------------------------------------------
const LBRGT_MAX_TAG_ROWS = 2;

function clampTagRows(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const gruppen = [...scope.querySelectorAll(".lbrgt-tags")].map((c) => [
    ...c.querySelectorAll(".lbrgt-tag"),
  ]);
  if (!gruppen.length) return;

  // Drei getrennte Durchgaenge, damit der Browser nur einmal neu umbrechen muss:
  // erst alles einblenden, dann alle Positionen lesen, dann ausblenden. Wer je
  // Element schreibt und liest, erzwingt pro Badge ein Layout.
  gruppen.forEach((tags) => tags.forEach((t) => { t.hidden = false; }));
  const positionen = gruppen.map((tags) => tags.map((t) => t.offsetTop));

  gruppen.forEach((tags, i) => {
    let reihen = 0;
    let letzteKante = null;
    tags.forEach((tag, j) => {
      const oben = positionen[i][j];
      // Neue Reihe, sobald ein Badge tiefer beginnt als das vorige. Ein Pixel
      // Toleranz gegen Rundungsfehler bei gebrochenen Zoomstufen.
      if (letzteKante === null || oben > letzteKante + 1) {
        reihen += 1;
        letzteKante = oben;
      }
      if (reihen > LBRGT_MAX_TAG_ROWS) tag.hidden = true;
    });
  });
}

// Die Schriften laden mit font-display: swap (layout/theme.liquid:34). Vor dem
// Wechsel gemessene Breiten stammen von der Ersatzschrift und stimmen nicht -
// deshalb nach dem Laden noch einmal.
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(() => clampTagRows());
}

let lbrgtTagRowTimer;
window.addEventListener("resize", () => {
  clearTimeout(lbrgtTagRowTimer);
  lbrgtTagRowTimer = setTimeout(() => { clampTagRows(); initScrollHints(document); }, 150);
});

// Beim Filtern ersetzt der Facettenfilter den kompletten Inhalt von
// #filter-results per innerHTML (assets/facet-filters.js:258) und feuert danach
// dieses Ereignis (:303). Die Karten danach sind neue Knoten, an denen keine
// Listener mehr haengen - die Farbkacheln muessen also neu verdrahtet werden.
document.addEventListener("on:facet-filters:updated", () => {
  clampTagRows();
  clpthumbnail(document.getElementById("filter-results"));
});

// Endlos-Scroll und "Mehr laden" haengen Karten an, ohne ein Ereignis zu feuern
// (assets/custom-pagination.js). Deshalb beobachten statt lauschen.
function watchPaginationForCards() {
  document.querySelectorAll("custom-pagination").forEach((liste) => {
    if (liste.dataset.lbrgtTagWatch) return;
    liste.dataset.lbrgtTagWatch = "true";
    // Ein Nachladeschub loest mehrere Mutationen aus - deshalb einmal sammeln
    // und erst danach messen. Beobachtet wird nur childList, das Setzen von
    // hidden ist eine Attributaenderung und kann sich nicht selbst ausloesen.
    let timer;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        clampTagRows(liste);
        clpthumbnail(liste);
      }, 50);
    }).observe(liste, { childList: true, subtree: true });
  });
}
document.addEventListener("DOMContentLoaded", watchPaginationForCards);

// Der Theme-Editor tauscht bei jeder Aenderung die betroffene Section aus. Die
// Ereignisse oben haengen aber nur an DOMContentLoaded, deshalb verlieren die
// Farbkacheln danach im Editor ihr Verhalten - Hover, Klick und der
// Auswahlzustand tun nichts mehr, waehrend sie in der Vorschau funktionieren.
// Andere Dateien im Theme machen es an dieser Stelle bereits richtig, etwa
// assets/lbrgt-custom-slider.js:162 und assets/main.js:860.
//
// Deckt NUR den Editor ab: shopify:section:load wird im Theme nirgends
// dispatcht, das Ereignis kommt allein vom Theme-Editor. Filter und
// Endlos-Scroll haengen deshalb an den beiden Stellen weiter oben.
document.addEventListener("shopify:section:load", (evt) => {
  clpthumbnail(evt.target);
  clampTagRows(evt.target);
  watchPaginationForCards();
});

//mobile menu tabs
function initTabs() {
  const triggers = document.querySelectorAll("[data-tab-trigger]");
  const panels = document.querySelectorAll("[data-tab-content]");

  if (!triggers.length || !panels.length) return;

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const target = trigger.dataset.tabTrigger;

      triggers.forEach((button) => {
        button.classList.remove("is-active");
      });

      panels.forEach((panel) => {
        panel.classList.remove("is-active");
      });

      trigger.classList.add("is-active");

      const activePanel = document.querySelector(
        `[data-tab-content="${target}"]`,
      );

      activePanel?.classList.add("is-active");
    });
  });
}

//toggle buttons in multi column sections
function initToggleGroups() {
  const sections = document.querySelectorAll(".lbrgt-multi-col");

  sections.forEach((section) => {
    const buttons = section.querySelectorAll(".toggle-btn");
    const items = section.querySelectorAll("[data-toggle-group]");

    if (!buttons.length || !items.length) return;

    const filterItems = (group) => {
      items.forEach((item) => {
        const itemGroup = item.dataset.toggleGroup;

        item.style.display =
          itemGroup === group || itemGroup === "both" ? "" : "none";
      });
    };

    filterItems("group_1");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        buttons.forEach((btn) => {
          btn.classList.remove("active");
        });

        button.classList.add("active");

        filterItems(button.dataset.toggle);
      });
    });
  });
}

//product slider on homepage
function initProductSlider() {
  // Der frueher hier gebundene Klick-Handler fuer .lbrgt-thumb ist entfernt.
  // Er lag auf denselben Kacheln wie clpthumbnail, tat mit dem Bildwechsel
  // dasselbe und rief zusaetzlich preventDefault - deshalb passierte beim
  // Klick auf die Farbkachel nichts weiter. Jede .lbrgt-card traegt auch die
  // Klasse .card (siehe snippets/lbrgt-product-card.liquid), wird von
  // clpthumbnail also ohnehin erfasst - dort inklusive Auswahlzustand,
  // Varianten-Link und Navigation.

  const sliders = document.querySelectorAll(".lbrgt-carousel");
  sliders.forEach((section) => {
    const slider = section.querySelector(".slider");
    const slides = [...section.querySelectorAll(".slider__item")];
    const dotsWrapper = section.querySelector(".lbrgt-slider-dots");
    if (!slider || !slides.length || !dotsWrapper) return;
    function getItemsPerPage() {
      const sliderWidth = slider.clientWidth;
      const slideWidth = slides[0].getBoundingClientRect().width;
      return Math.max(1, Math.round(sliderWidth / slideWidth));
    }
    function getPageCount() {
      return Math.max(
        1,
        slides.length - getItemsPerPage() + 1
      );
    }
    function getCurrentPage() {
      const slideWidth = slides[0].offsetWidth;
      return Math.round(slider.scrollLeft / slideWidth);
    }
    function updateDots() {
      const current = getCurrentPage();
      dotsWrapper.querySelectorAll(".lbrgt-dot").forEach((dot, index) => {
        const isActive = index === current;
        dot.classList.toggle("active", isActive);
        if (isActive) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    }
    function createDots() {
      dotsWrapper.innerHTML = "";
      const pages = getPageCount();
      for (let page = 0; page < pages; page++) {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "lbrgt-dot";
        dot.setAttribute("aria-label", `Zu Seite ${page + 1} wechseln`);
        if (page === 0) {
          dot.classList.add("active");
          dot.setAttribute("aria-current", "true");
        }
        dot.addEventListener("click", () => {
          const slideIndex = page * getItemsPerPage();
          if (!slides[slideIndex]) return;
          slider.scrollTo({
            left: slides[slideIndex].offsetLeft,
            behavior: "smooth"
          });
        });
        dotsWrapper.appendChild(dot);
      }
    }
    createDots();
    let timer;
    slider.addEventListener("scroll", updateDots);
    window.addEventListener("resize", () => {
      createDots();
      updateDots();
    });
    updateDots();
  });
}

//cart popup slider
function initPopupRecommendedSlider() {
  document.querySelectorAll(".popup-recommended-carousel").forEach((section) => {
    if (section.dataset.popupInit) return;
    section.dataset.popupInit = "true";
    const slider = section.querySelector(".products-grid-container");
    const slides = [...section.querySelectorAll(".slider__item")];
    const prev = section.querySelector(".lbrgt-cart-prev");
    const next = section.querySelector(".lbrgt-cart-next");
    const dots = section.querySelector(".lbrgt-cart-slider-dots");
    if (!slider || !slides.length) return;
    const perPage = () => {
        if (window.innerWidth >= 990) return 3;
        if (window.innerWidth >= 768) return 2;
        return 1;
    };
    const pageCount = () => Math.ceil(slides.length / perPage());
    function createDots() {
        dots.innerHTML = "";
        for (let i = 0; i < pageCount(); i++) {
            const dot = document.createElement("button");
            dot.className = "lbrgt-cart-dot";
            if (i === 0)
                dot.classList.add("active");
            dot.onclick = () => {
                slider.scrollTo({
                    left: slider.clientWidth * i,
                    behavior: "smooth"
                });
            };
            dots.appendChild(dot);
        }
    }
    function updateDots() {
        const current = Math.round(slider.scrollLeft / slider.clientWidth);
        dots.querySelectorAll(".lbrgt-cart-dot").forEach((dot, i) => {
            dot.classList.toggle("active", i === current);
        });
    }
    next.onclick = () => {
        slider.scrollBy({
            left: slider.clientWidth,
            behavior: "smooth"
        });
    };
    prev.onclick = () => {
        slider.scrollBy({
            left: -slider.clientWidth,
            behavior: "smooth"
        });
    };
    slider.addEventListener("scroll", updateDots);
    window.addEventListener("resize", () => {
        createDots();
        updateDots();
    });
    createDots();
    updateDots();
  });
}

//testimonial slider
function initTestimonialsSlider() {
  const sections = document.querySelectorAll(".testimonials-custom");

  sections.forEach((section) => {
    const slider = section.querySelector(".testimonials-custom__track");

    if (!slider) return;

    const prevBtn = section.querySelector('[id^="prev-"]');
    const nextBtn = section.querySelector('[id^="next-"]');
    const dots = section.querySelectorAll(".page-btn");

    const originalSlides = Array.from(
      slider.querySelectorAll(".testimonials-custom__slide"),
    );

    let perView = getPerView();
    let currentIndex = 0;
    let isTransitioning = false;
    let autoplayInterval;
    let autoplayPaused = false;

    function getPerView() {
      const viewport = slider.closest(".testimonials-custom__viewport");
      if (!viewport) return 1;
      return viewport.offsetWidth < 768
        ? 1
        : Number(section.dataset.desktopColumns || 3);
    }

    function moveToSlide(index) {
      const moveAmount = (100 / perView) * index;
      slider.style.transform = `translateX(-${moveAmount}%)`;
    }

    function updateDots() {
      dots.forEach((dot) => {
        dot.removeAttribute("aria-current");
      });
      let realIndex = currentIndex - perView;
      if (realIndex < 0) {
        realIndex = originalSlides.length - 1;
      }
      if (realIndex >= originalSlides.length) {
        realIndex = 0;
      }
      dots[realIndex]?.setAttribute("aria-current", "true");
    }

    function setupInfiniteSlider() {
      perView = getPerView();
      currentIndex = perView;
      slider.innerHTML = "";
      const beforeClones = originalSlides
        .slice(-perView)
        .map((slide) => slide.cloneNode(true));

      const afterClones = originalSlides
        .slice(0, perView)
        .map((slide) => slide.cloneNode(true));

      const allSlides = [...beforeClones, ...originalSlides, ...afterClones];

      allSlides.forEach((slide) => {
        slide.style.minWidth = `${100 / perView}%`;
        slide.style.flex = `0 0 ${100 / perView}%`;
        slider.appendChild(slide);
      });

      requestAnimationFrame(() => {
        slider.style.transition = "none";
        moveToSlide(currentIndex);
        requestAnimationFrame(() => {
          slider.style.transition = "transform .5s ease";
        });
      });
    }
    function nextSlide() {
      if (isTransitioning) return;
      isTransitioning = true;
      currentIndex++;
      moveToSlide(currentIndex);
      updateDots();
    }
    function prevSlide() {
      if (isTransitioning) return;
      isTransitioning = true;
      currentIndex--;
      moveToSlide(currentIndex);
      updateDots();
    }
    slider.addEventListener("transitionend", () => {
      if (currentIndex >= originalSlides.length + perView) {
        slider.style.transition = "none";
        currentIndex = perView;
        moveToSlide(currentIndex);
      }
      if (currentIndex <= 0) {
        slider.style.transition = "none";
        currentIndex = originalSlides.length;
        moveToSlide(currentIndex);
      }
      setTimeout(() => {
        slider.style.transition = "transform .5s ease";
      }, 20);

      isTransitioning = false;
    });

    nextBtn?.addEventListener("click", nextSlide);
    prevBtn?.addEventListener("click", prevSlide);
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        if (isTransitioning) return;
        currentIndex = index + perView;
        moveToSlide(currentIndex);
        updateDots();
      });
    });

    let resizeTimeout;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const oldPerView = perView;

        perView = getPerView();

        if (oldPerView !== perView) {
          slider.style.transition = "none";
          currentIndex = perView;
          setupInfiniteSlider();
          moveToSlide(currentIndex);
          updateDots();
        }
      }, 150);
    });
    // autoplay
    if (section.dataset.autoplay === "true") {
      const autoplaySpeed = Number(section.dataset.autoplaySpeed || 5) * 1000;

      function startAutoplay() {
        stopAutoplay();
        autoplayInterval = setInterval(() => {
          if (!autoplayPaused && !isTransitioning) {
            nextSlide();
          }
        }, autoplaySpeed);
      }

      function stopAutoplay() {
        clearInterval(autoplayInterval);
      }
      function pauseAutoplay() {
        autoplayPaused = true;
        stopAutoplay();
      }
      function resumeAutoplay() {
        autoplayPaused = false;
        startAutoplay();
      }
      startAutoplay();
      slider.addEventListener("mouseenter", pauseAutoplay);
      slider.addEventListener("mouseleave", resumeAutoplay);
      slider.addEventListener("touchstart", pauseAutoplay, {
        passive: true,
      });
      slider.addEventListener("touchend", resumeAutoplay);
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          pauseAutoplay();
        } else {
          resumeAutoplay();
        }
      });
    }
    setupInfiniteSlider();
    updateDots();
  });
}

//collection filters
document.querySelectorAll('.custom-top-filters input[type="checkbox"]')
  .forEach((cb) => {
    cb.addEventListener("change", () => {
      document
        .querySelector(".facets__filters")
        .dispatchEvent(new Event("input", { bubbles: true }));
    });
  });

// Fixed by Julius
// root optional: erlaubt das erneute Binden nur innerhalb einer nachgeladenen
// Section, statt jedes Mal alle Karten der Seite erneut zu verdrahten.
// Die Farbkacheln sind seit dem Umbau echte <a>-Links. Navigation, Vorladen
// beim Hovern (assets/instant-page.js) und das Abbrechen eines laufenden
// Endlos-Scroll-Abrufs (assets/custom-pagination.js, handleResultClick) macht
// damit der Browser bzw. das Theme von selbst. Hier bleibt nur noch die
// Vorschau: Bild wechseln, Auswahl markieren, Kartenlinks nachziehen.
// Scroll-Hinweis (Chevron) am Varianten-Slider: zeigt an, dass horizontal
// gescrollt werden kann. Klasse lbrgt-can-scroll wenn der Strip ueberlaeuft,
// lbrgt-at-end wenn ganz nach rechts gescrollt (Chevron wird dann ausgeblendet).
function updateScrollHint(strip) {
  const wrap = strip.closest(".lbrgt-thumbnails-wrap");
  if (!wrap) return;
  const canScroll = strip.scrollWidth - strip.clientWidth > 4;
  wrap.classList.toggle("lbrgt-can-scroll", canScroll);
  const atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
  wrap.classList.toggle("lbrgt-at-end", atEnd);
}

function initScrollHints(root) {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll(".lbrgt-thumbnails").forEach(function (strip) {
    updateScrollHint(strip);
    if (strip.dataset.lbrgtHintBound) return;
    strip.dataset.lbrgtHintBound = "true";
    strip.addEventListener("scroll", function () { updateScrollHint(strip); }, { passive: true });

    // Klick auf den Chevron scrollt eine Kachel weiter, statt das Produkt zu oeffnen.
    const wrap = strip.closest(".lbrgt-thumbnails-wrap");
    const hint = wrap ? wrap.querySelector(".lbrgt-scroll-hint") : null;
    if (hint) {
      hint.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const tile = strip.querySelector(".lbrgt-thumb");
        const step = tile ? tile.offsetWidth + 8 : 68;
        strip.scrollBy({ left: step, behavior: "smooth" });
      });
    }
  });
}

function clpthumbnail(root) {
  const supportsHover = window.matchMedia("(hover: hover)").matches;
  const scope = root && root.querySelectorAll ? root : document;

  scope.querySelectorAll(".card").forEach(function (card) {
    const mainImage = card.querySelector(".lbrgt-main-image");
    if (!mainImage) return;

    const prodLinks = card.querySelectorAll(".js-prod-link");
    const thumbs = card.querySelectorAll(".lbrgt-thumb");
    const neuBadge = card.querySelector(".lbrgt-neu-variant");
    const saleBadge = card.querySelector(".lbrgt-sale-variant");
    const priceEl = card.querySelector(".price");

    // NEU-Label folgt der aktiven Farbe: sichtbar nur, wenn die gewaehlte Kachel
    // als neu markiert ist (data-neu). Beim Quick-Select-Hover wird das mitgezogen.
    function applyNeu(thumb) {
      if (!neuBadge) return;
      neuBadge.classList.toggle("is-visible", !!thumb && thumb.dataset.neu === "true");
    }

    // SALE-Label folgt der aktiven Farbe (data-on-sale der Kachel) - analog NEU.
    // Nur die B2C-Produktkarte rendert .lbrgt-sale-variant (per-Farbe-Modus).
    function applySale(thumb) {
      // Fehlt data-on-sale (z.B. else-Zweig-Kachel eines farblosen Produkts), den
      // serverseitig gerenderten is-visible-Zustand NICHT ueberschreiben - sonst
      // verschwaende ein reduziertes farbloses Produkt sein Sale-Badge beim Init.
      if (!saleBadge || !thumb || thumb.dataset.onSale === undefined) return;
      saleBadge.classList.toggle("is-visible", thumb.dataset.onSale === "true");
    }

    // Preis folgt der aktiven Farbe: Server rendert initial die angezeigte Farbe,
    // hier wird beim Hover der Preis + Streichpreis + on-sale-Zustand der gehoverten
    // Farbe gesetzt (data-price/data-compare-at/data-on-sale). innerHTML, weil
    // price-as-money je nach Setting Markup (z.B. Hochkommas) enthalten kann.
    function applyPrice(thumb) {
      if (!priceEl || !thumb || !thumb.dataset.price) return;
      const cur = priceEl.querySelector(".price__current .js-value");
      const was = priceEl.querySelector(".price__was .js-value");
      if (cur) cur.innerHTML = thumb.dataset.price;
      if (was) was.innerHTML = thumb.dataset.compareAt || "";
      priceEl.classList.toggle("price--on-sale", thumb.dataset.onSale === "true");
    }

    thumbs.forEach(function (thumb) {
      // Nach Filter und Endlos-Scroll laeuft die Funktion erneut ueber Karten,
      // die teilweise schon verdrahtet sind. selectThumb wird bei jedem Aufruf
      // neu erzeugt, ist also nie dieselbe Funktionsreferenz - ohne diese Marke
      // sammelte jede Kachel mit jedem Durchlauf einen weiteren Listener an.
      if (thumb.dataset.lbrgtThumbBound) return;
      thumb.dataset.lbrgtThumbBound = "true";

      function selectThumb() {
        mainImage.src = thumb.dataset.image;
        if (thumb.dataset.srcset) {
          mainImage.srcset = thumb.dataset.srcset;
        }

        // move the selected border
        thumbs.forEach((t) => t.classList.remove("selected"));
        thumb.classList.add("selected");

        // update product/variant links
        if (thumb.dataset.variantUrl) {
          prodLinks.forEach((link) => {
            link.href = thumb.dataset.variantUrl;
          });
        }

        applyNeu(thumb);
        applySale(thumb);
        applyPrice(thumb);
      }

      // Vorschau beim Hovern. Nur wo es echten Hover gibt - auf Touch fuehrt
      // die Beruehrung ohnehin direkt zum Link.
      if (supportsHover) {
        thumb.addEventListener("mouseenter", selectThumb);
      }
    });

    // Ausgangszustand aus der aktuell gewaehlten Kachel setzen (data-neu ist die
    // eigentliche Wahrheit). Nur wenn es Kacheln gibt - ohne Strip (Einzelbild-Karten,
    // Empfehlungs-Sektionen) bleibt der serverseitige Zustand (card_neu) stehen, statt
    // das Neu faelschlich zu verstecken.
    if (thumbs.length) {
      const lbrgtInitThumb = card.querySelector(".lbrgt-thumb.selected") || thumbs[0];
      applyNeu(lbrgtInitThumb);
      applySale(lbrgtInitThumb);

      if (lbrgtInitThumb.dataset.variantUrl) {
        prodLinks.forEach((link) => {
          link.href = lbrgtInitThumb.dataset.variantUrl;
        });
      }
      
      // Preis NICHT hier setzen: der Server rendert bereits die angezeigte Farbe
      // (use_variant), das vermeidet ein Flackern. Hover uebernimmt via applyPrice.
    }
  });

  initScrollHints(scope);
}

//Product thumnb
function initProductThumbs() {
  function init() {
    document
      .querySelectorAll(".custom-product-thumbs")
      .forEach(function (slider) {
        var card = slider.closest("product-card");
        var mainImg = card ? card.querySelector(".custom-main-image") : null;

        slider.querySelectorAll(".custom-thumb").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var newSrc = btn.dataset.src;
            var newSrcset = btn.dataset.srcset;

            if (mainImg && newSrc) {
              mainImg.src = newSrc;

              if (newSrcset) {
                mainImg.srcset = newSrcset;
              }
            }

            slider.querySelectorAll(".custom-thumb").forEach(function (b) {
              b.classList.remove("active");
            });

            btn.classList.add("active");
            btn.scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          });
        });
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}

//size switcher
function updateSizeTabsActiveState() {
  const type = SizeConversion.getType();
  document.querySelectorAll('[data-size-conversion-container]').forEach((container) => {
    container.querySelectorAll('.size-tab').forEach((tab) => {
      tab.classList.toggle('active', tab.dataset.sizeType === type);
    });
  });
}

//size tabs
(() => {
  function applySizeType() {
    // Anzeige laeuft rein ueber CSS: die Labels tragen beide Einheiten
    // (lbrgt-su--eu / --uk), und :root[data-size-unit] entscheidet, welche
    // sichtbar ist. Hier nur die Wahrheitsquelle setzen - KEIN textContent-
    // Rewrite mehr (der wuerde die Dual-Value-Spans zerstoeren) und damit kein
    // Flash beim Laden oder Variantenwechsel.
    document.documentElement.setAttribute('data-size-unit', SizeConversion.getType());
  }

  function applyToAllPickers() {
    applySizeType();
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.size-tab');
    if (!tab) return;

    const picker = tab.closest("[data-size-conversion-container], variant-picker");
    if (!picker) return;

    SizeConversion.setType(tab.dataset.sizeType);
  });

  document.addEventListener('size-conversion:change', () => {
    updateSizeTabsActiveState();
    applyToAllPickers();

    //this function for when change the tab like EU or UK than get the selected product size and set in input
    const selectedVariant = document.querySelector(
        '.js-option:checked'
    );
    if (!selectedVariant) return;
    const variantId = selectedVariant.dataset.variantId;
    // updateSelectedSizeProperty ist NUR auf der PDP definiert
    // (lbrgt-b2c-delivery-dates.liquid). Auf Cart-/Collection-Seiten ist die
    // Funktion undefined -> der Aufruf warf hier bei jedem EU/UK-Klick einen
    // TypeError und brach die Kette. Die Drawer-Groessen-Property wird ohnehin
    // gescopt von lbrgt-quickbuy-stock.js gesetzt.
    if (typeof window.updateSelectedSizeProperty === 'function') {
      window.updateSelectedSizeProperty(variantId);
    }
  });
  

  /**
   * Keep this observer because Enterprise dynamically injects
   * variant pickers (Quick Add, section rendering, etc.).
   */
  let scheduled = false;

  const observer = new MutationObserver((mutations) => {
    if (scheduled) return;

    const shouldUpdate = mutations.some((mutation) => {
      if (mutation.target.nodeType === Node.ELEMENT_NODE &&
          mutation.target.closest?.('variant-picker')) {
        return true;
      }
      return [...mutation.addedNodes].some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.('variant-picker') ||
            node.querySelector?.('variant-picker'))
      );
    });

    if (!shouldUpdate) return;

    scheduled = true;

    requestAnimationFrame(() => {
      updateSizeTabsActiveState();
      applyToAllPickers();
      scheduled = false;
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('beforeunload', () => observer.disconnect());

  applyToAllPickers();
})();

//facet size grid
(() => {
  function updateFacetLabels() {
    const type = SizeConversion.getType();
    document.querySelectorAll('[data-size]').forEach((label) => {
      const euSize = label.dataset.size;
      const converted = SizeConversion.convert(euSize);
      label.textContent = type === SizeConversion.SIZE_TYPES.UK ? converted.uk : converted.eu;
    });
  }

  document.addEventListener('size-conversion:change', () => {
    updateSizeTabsActiveState();
    updateFacetLabels();
  });

  document.addEventListener('on:facet-filters:updated', () => {
    updateSizeTabsActiveState();
    updateFacetLabels();
  });
  updateSizeTabsActiveState();
  updateFacetLabels();
})();

// PDP specification update on variant change - Julius
document.addEventListener('change', (e) => {
  const input = e.target.closest('.js-option[data-variant-id]');
  if (!input) return;

  const variantId = input.dataset.variantId;

  document.querySelectorAll('[data-spec-map]').forEach((el) => {
    const map = JSON.parse(el.dataset.specMap);
    const value = map[variantId];

    el.innerHTML = value || '';
    el.closest('[data-spec-item]')?.style.setProperty('display', value ? '' : 'none');
  });
});

// PDP media-with-text update on variant change - Julius
document.addEventListener('change', (e) => {
  const input = e.target.closest('.js-option[data-variant-id]');
  if (!input) return;

  const variantId = input.dataset.variantId;

  document.querySelectorAll('[data-media-text-map]').forEach((item) => {
    const map = JSON.parse(item.dataset.mediaTextMap);
    const data = map[variantId];
    if (!data) return;

    item.style.display = data.visible ? '' : 'none';

    const headlineEl = item.querySelector('[data-media-text-headline]');
    if (headlineEl) {
      headlineEl.innerHTML = data.headline;
      headlineEl.style.display = data.headline ? '' : 'none';
    }

    const textEl = item.querySelector('[data-media-text-text]');
    if (textEl) {
      textEl.innerHTML = data.text;
      textEl.style.display = data.text ? '' : 'none';
    }

    // Media-Wrapper je hasImage ein-/ausblenden: der Container ist jetzt immer im
    // DOM (Fallback any_image in der Section), aber nur Varianten MIT Bild zeigen ihn.
    // Ohne das blieb das Bild beim Farbwechsel unsichtbar, weil der Container bei
    // einer bildlosen Startvariante fehlte.
    const mediaEl = item.querySelector('[data-media-text-media]');
    const mediaWrap = item.querySelector('[data-media-text-wrapper]');
    if (mediaEl) {
      if (data.hasImage) {
        mediaEl.innerHTML = data.image;
        if (data.ratio) mediaEl.style.paddingTop = data.ratio + '%';
        if (mediaWrap) mediaWrap.style.display = '';
      } else {
        mediaEl.innerHTML = '';
        if (mediaWrap) mediaWrap.style.display = 'none';
      }
    }
  });
});

// B2B size+qty grid — EU/UK toggle - Julius
document.addEventListener("click", (e) => {
  const toggleBtn = e.target.closest("[data-b2b-size-qty] .sq-toggle-btn");
  if (!toggleBtn) return;

  const widget = toggleBtn.closest("[data-b2b-size-qty]");
  if (!widget) return;

  widget.querySelectorAll(".sq-toggle-btn").forEach((b) => {
    b.classList.remove("active");
  });
  toggleBtn.classList.add("active");

  const type = toggleBtn.dataset.sizeType;
  widget.querySelectorAll(".sq-size-label").forEach((span) => {
    const euSize = span.dataset.euSize;
    if (type === "eu" || !euSize) {
      span.textContent = euSize;
      return;
    }
    span.textContent = window.sizeConversion?.[euSize]?.[type] || euSize;
  });
});

// Collapsible card
function initCardContentToggle() {
  const sections = document.querySelectorAll("[id^='shopify-section-']");
  sections.forEach((section) => {
    const triggers = section.querySelectorAll("[data-card-trigger]");
    const cards = section.querySelectorAll(".lgbrt-card");
    const contentAreas = section.querySelectorAll("[data-content-area]");
    const resultsWrapper = section.querySelector(".lgbrt-multimedia-results");

    if (!triggers.length) return;

    function resetContentPosition() {
      if (!resultsWrapper) return;
      contentAreas.forEach((area) => {
        if (
          area.parentElement &&
          area.parentElement.classList.contains("lgbrt-card-grid")
        ) {
          resultsWrapper.appendChild(area);
        }
      });
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const targetId = trigger.dataset.cardTrigger;
        const activeCard = trigger.closest(".lgbrt-card");
        const activeContent = section.querySelector(
          `[data-content-area="${targetId}"]`,
        );
        const isAlreadyOpen =
          activeCard?.classList.contains("active") &&
          activeContent?.classList.contains("active");

        // Remove active states
        cards.forEach((card) => {
          card.classList.remove("active");
        });
        contentAreas.forEach((area) => {
          area.classList.remove("active");
        });
        // Reset content locations on mobile before opening another one
        if (window.innerWidth < 769) {
          resetContentPosition();
        }
        // Close if already open
        if (isAlreadyOpen) {
          return;
        }
        activeCard?.classList.add("active");
        if (activeContent) {
          if (window.innerWidth < 769) {
            activeCard?.insertAdjacentElement("afterend", activeContent);
          }
          // Wait for DOM update before activating and scrolling
          requestAnimationFrame(() => {
            activeContent.classList.add("active");
            requestAnimationFrame(() => {
              activeContent.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            });
          });
        }
      });
    });

    // Handle switching between mobile and desktop
    let isMobile = window.innerWidth < 769;
    window.addEventListener("resize", () => {
      const mobileNow = window.innerWidth < 769;
      if (mobileNow === isMobile) return;
      isMobile = mobileNow;
      cards.forEach((card) => {
        card.classList.remove("active");
      });
      contentAreas.forEach((area) => {
        area.classList.remove("active");
      });
      resetContentPosition();
    });
  });
}

// Jobs filter
function initJobsSections() {
  document.querySelectorAll("[data-jobs-section]").forEach((section) => {
    const sectionId = section.dataset.sectionId;
    const countLabel = section.dataset.countLabel || "Jobs";

    const table = document.getElementById(`lbrgt-table-${sectionId}`);
    const tbody = document.getElementById(`lbrgt-tbody-${sectionId}`);
    const countEl = document.getElementById(`lbrgt-count-${sectionId}`);
    const emptyEl = document.getElementById(`lbrgt-empty-${sectionId}`);
    const searchEl = document.getElementById(`lbrgt-search-${sectionId}`);
    const filter1El = document.getElementById(`lbrgt-filter1-${sectionId}`);
    const filter2El = document.getElementById(`lbrgt-filter2-${sectionId}`);
    const showMoreWrap = document.getElementById(
      `lbrgt-showmore-wrap-${sectionId}`,
    );
    const showMoreBtn = document.getElementById(`lbrgt-showmore-${sectionId}`);

    if (!tbody) return;

    const rows = Array.from(tbody.querySelectorAll("tr[data-row]"));

    // Build dropdown options
    function buildFilterOptions(selectEl) {
      if (!selectEl) return;

      const colIndex = parseInt(selectEl.getAttribute("data-filter-col"), 10);

      if (!colIndex) return;

      const seen = {};

      rows.forEach((row) => {
        const cell = row.querySelector(`td[data-col="${colIndex}"]`);

        if (!cell) return;

        const value = cell.textContent.trim();

        if (value && !seen[value]) {
          seen[value] = true;

          const option = document.createElement("option");
          option.value = value;
          option.textContent = value;

          selectEl.appendChild(option);
        }
      });
    }

    buildFilterOptions(filter1El);
    buildFilterOptions(filter2El);

    let mobileExpanded = false;
    const MOBILE_INITIAL = 4;

    function isMobile() {
      return window.innerWidth <= 600;
    }

    function applyMobileShowMore() {
      if (!showMoreBtn) return;

      const visibleRows = rows.filter(
        (row) => row.getAttribute("data-hidden") !== "true",
      );

      if (!isMobile() || visibleRows.length <= MOBILE_INITIAL) {
        visibleRows.forEach((row) => row.removeAttribute("data-mobile-hidden"));

        if (showMoreWrap) {
          showMoreWrap.style.display = "none";
        }

        return;
      }

      if (showMoreWrap) {
        showMoreWrap.style.display = "";
      }

      if (mobileExpanded) {
        visibleRows.forEach((row) => row.removeAttribute("data-mobile-hidden"));
      } else {
        visibleRows.forEach((row, index) => {
          row.setAttribute(
            "data-mobile-hidden",
            index >= MOBILE_INITIAL ? "true" : "false",
          );
        });
      }
    }

    function applyFilters() {
      const searchValue = searchEl ? searchEl.value.trim().toLowerCase() : "";

      const filter1Value = filter1El
        ? filter1El.value.trim().toLowerCase()
        : "";

      const filter2Value = filter2El
        ? filter2El.value.trim().toLowerCase()
        : "";

      const filter1Col = filter1El
        ? parseInt(filter1El.getAttribute("data-filter-col"), 10)
        : 0;

      const filter2Col = filter2El
        ? parseInt(filter2El.getAttribute("data-filter-col"), 10)
        : 0;

      let visibleCount = 0;

      rows.forEach((row) => {
        let show = true;

        if (searchValue) {
          const searchText = row.getAttribute("data-search-text") || "";

          if (!searchText.includes(searchValue)) {
            show = false;
          }
        }

        if (show && filter1Value && filter1Col) {
          const cell = row.querySelector(`td[data-col="${filter1Col}"]`);

          if (!cell || cell.textContent.trim().toLowerCase() !== filter1Value) {
            show = false;
          }
        }

        if (show && filter2Value && filter2Col) {
          const cell = row.querySelector(`td[data-col="${filter2Col}"]`);

          if (!cell || cell.textContent.trim().toLowerCase() !== filter2Value) {
            show = false;
          }
        }

        row.setAttribute("data-hidden", show ? "false" : "true");

        if (show) {
          visibleCount++;
        }
      });

      if (countEl) {
        countEl.textContent = `${visibleCount} ${countLabel}`;
      }

      if (emptyEl) {
        emptyEl.classList.toggle("is-visible", visibleCount === 0);
      }

      mobileExpanded = false;
      applyMobileShowMore();
    }

    if (searchEl) {
      searchEl.addEventListener("input", applyFilters);
    }

    if (filter1El) {
      filter1El.addEventListener("change", applyFilters);
    }

    if (filter2El) {
      filter2El.addEventListener("change", applyFilters);
    }

    if (showMoreBtn) {
      showMoreBtn.addEventListener("click", () => {
        mobileExpanded = true;

        applyMobileShowMore();

        if (showMoreWrap) {
          showMoreWrap.style.display = "none";
        }

        showMoreBtn.setAttribute("aria-expanded", "true");
      });
    }

    window.addEventListener("resize", applyMobileShowMore);

    applyFilters();
    applyMobileShowMore();
  });
}

//service area slider/cards
function initSliderDots() {
  const sections = document.querySelectorAll("[id^='shopify-section-']");
  sections.forEach((section) => {
    const slider = section.querySelector(".slider");
    const slides = section.querySelectorAll(".slider__item");
    const dotsWrapper = section.querySelector(".lbrgt-slider-dots");
    if (!slider || !slides.length || !dotsWrapper) return;
    // Prevent duplicate initialization
    if (slider.dataset.dotsInitialized) return;
    slider.dataset.dotsInitialized = "true";
    dotsWrapper.innerHTML = "";
    slides.forEach((slide, index) => {
      const dot = document.createElement("button");
      dot.classList.add("lbrgt-dot");
      dot.setAttribute("aria-label", `Zu Seite ${index + 1} wechseln`);
      if (index === 0) {
        dot.classList.add("active");
        dot.setAttribute("aria-current", "true");
      }
      dot.addEventListener("click", () => {
        slider.scrollTo({
          left: slide.offsetLeft,
          behavior: "smooth",
        });
      });

      dotsWrapper.appendChild(dot);
    });
    slider.addEventListener("scroll", () => {
      const slideWidth = slides[0].offsetWidth;
      const currentIndex = Math.round(slider.scrollLeft / slideWidth);
      const dots = dotsWrapper.querySelectorAll(".lbrgt-dot");
      dots.forEach((dot) => {
        dot.classList.remove("active");
      });

      if (dots[currentIndex]) {
        dots[currentIndex].classList.add("active");
      }
    });
    // Active card handling
    const cards = section.querySelectorAll(".service-area-card");

    cards.forEach((card) => {
      card.addEventListener("click", () => {
        cards.forEach((item) => {
          item.classList.remove("active");
        });
        card.classList.add("active");
      });
    });
    const currentPath = window.location.pathname;
    cards.forEach((card) => {
      const cardUrl = new URL(card.href);
      if (cardUrl.pathname === currentPath) {
        card.classList.add("active");
      }
    });
  });
}

//cart count update
(function () {
  function updateCustomCartCount() {
    const badges = document.querySelectorAll(".js-cart-item-count");
    if (!badges.length) {
      return;
    }
    fetch("/cart.js", {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(cart => {

            // Update custom badge
            badges.forEach(badge => {
                badge.textContent = `(${cart.item_count})`;
            });

            // Cart items container
            const cartItems = document.querySelector('.cc-main-cart .cart__items');

            if (cartItems) {
                if (cart.item_count === 0) {
                    cartItems.style.maxWidth = '100%';
                } else {
                    cartItems.style.maxWidth = '';
                }
            }

        })
      .catch(function (error) {
        console.error("Cart count update failed:", error);
      });
  }

  // Page Load
  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname === "/cart") {
      updateCustomCartCount();
    }
  });

  // Observe cart bubble changes (Enterprise theme updates this automatically)
  const waitForBubble = setInterval(function () {
    const bubble = document.getElementById("cart-icon-bubble");

    if (!bubble) {
      return;
    }

    clearInterval(waitForBubble);
    const observer = new MutationObserver(function () {
      updateCustomCartCount();
    });
    observer.observe(bubble, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }, 100);
})();

// (only one top filter dropdown open at a time)
document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!details.matches('details')) return;

  if (!details.open) return;

  // Case 1: a top-filter dropdown opened - close sibling top-filter dropdowns
  const topFilterBar = details.closest('.custom-top-filters');
  if (topFilterBar) {
    topFilterBar.querySelectorAll('details[open]').forEach((otherDetails) => {
      if (otherDetails !== details) {
        otherDetails.open = false;
      }
    });
  }

  // Case 2: a filter inside the side drawer opened - close all top-filter dropdowns
  const insideSideDrawer = details.closest('#facet-filters, facet-filters');
  if (insideSideDrawer) {
    document.querySelectorAll('.custom-top-filters details[open]').forEach((topDetails) => {
      topDetails.open = false;
    });
  }
}, true);

// Case 3: the side drawer itself opens (via the "Filter" button) - close all top-filter dropdowns
document.addEventListener('click', (event) => {
  const filterToggleBtn = event.target.closest('.js-toggle-filters');
  if (!filterToggleBtn) return;

  document.querySelectorAll('.custom-top-filters details[open]').forEach((topDetails) => {
    topDetails.open = false;
  });
});

// sync top filter bar with sidebar facet-filters
document.addEventListener('on:facet-filters:updated', () => {
  const topFilterBar = document.querySelector('.custom-top-filters');
  const sidebarForm = document.getElementById('facets');
  if (!topFilterBar || !sidebarForm) return;

  // --- Sync each checkbox's checked/disabled state + count ---
  topFilterBar.querySelectorAll('input[type="checkbox"]').forEach((topInput) => {
    const matchingSidebarInput = sidebarForm.querySelector(
      `input[name="${CSS.escape(topInput.name)}"][value="${CSS.escape(topInput.value)}"]`
    );
    if (!matchingSidebarInput) return;

    topInput.checked = matchingSidebarInput.checked;
    topInput.disabled = matchingSidebarInput.disabled;

    const sidebarCountEl = matchingSidebarInput.closest('li')?.querySelector('.filter__count');
    const topCountText = topInput.closest('li')?.querySelector('.top-filter-count-text');
    const topBracketCount = topInput.closest('li')?.querySelector('.facet-size-grid__count');

    if (sidebarCountEl) {
      const match = sidebarCountEl.textContent.match(/\d+/);
      if (match) {
        if (topCountText) topCountText.textContent = match[0];
        if (topBracketCount) topBracketCount.textContent = `[${match[0]}]`;
      }
    }
  });

  const drawerFooterBtn = document.querySelector('.drawer__footer .js-close-drawer-mob');
  if (drawerFooterBtn) {
    const countMatch = drawerFooterBtn.textContent.match(/\d+/);
    if (countMatch) {
      const freshCount = countMatch[0];

      const topCountLabel = document.querySelector('.products-toolbar__count');
      if (topCountLabel) {
        topCountLabel.textContent = `${freshCount} Produkte`;
      }

      document.querySelectorAll('.top-filter-apply').forEach((applyBtn) => {
        applyBtn.textContent = applyBtn.textContent.replace(/\d+/, freshCount);
      });
    }
  }
});

// Scroll to top - Julius
(function () {
  const backToTop = document.querySelector('.back-to-top');
  if (!backToTop) return;

  backToTop.addEventListener('click', function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  const toggleVisibility = () => {
    if (window.scrollY > window.innerHeight) {
      backToTop.classList.add('is-visible');
    } else {
      backToTop.classList.remove('is-visible');
    }
  };

  window.addEventListener('scroll', toggleVisibility, { passive: true });
  toggleVisibility();
})();